module.exports = __webpack_public_path__ + "media/images/badges/yogasix/inactive/Y6Warrior2022_Badges_3500_Inactive@1x-6887f0ad41a93a4c4b2f229a43f67373.png";